module.exports = __webpack_public_path__ + "static/media/Abrey Mann.960ee68b.jpg";